import { createStyles, Theme } from '@material-ui/core';

export const commonClasses = (theme: Theme) => createStyles(
    {
        drawer:
        {
            width: '22vw',
            flexShrink: 0,
            [theme.breakpoints.down('lg')]:
            {
                width: '18vw'
            },
            [theme.breakpoints.down('md')]:
            {
                width: '24vw'
            },
            [theme.breakpoints.down('sm')]:
            {
                width: '22vw'
            },
            [theme.breakpoints.down('xs')]:
            {
                width: '70vw'
            }
        },
        drawerPaper :
		{
			width                          : '18vw',
			[theme.breakpoints.down('lg')] :
			{
				width : '18vw'
			},
			[theme.breakpoints.down('md')] :
			{
				width : '24vw'
			},
			[theme.breakpoints.down('sm')] :
			{
				width : '22vw'
			},
			[theme.breakpoints.down('xs')] :
			{
				width : '70vw'
			}
		},
        dialogPaper:
        {
            width: '15vw',
            padding: theme.spacing(2),
            [theme.breakpoints.down('lg')]:
            {
                width: '18vw'
            },
            [theme.breakpoints.down('md')]:
            {
                width: '24vw'
            },
            [theme.breakpoints.down('sm')]:
            {
                width: '22vw'
            },
            [theme.breakpoints.down('xs')]:
            {
                width: '70vw'
            }
        },
        dialogPaperPadding:
        {
            paddingRight: '24vw',
            [theme.breakpoints.down('lg')]:
            {
                paddingRight: '24vw'
            },
            [theme.breakpoints.down('md')]:
            {
                paddingRight: '38vw'
            },
            [theme.breakpoints.down('sm')]:
            {
                paddingRight: '29vw'
            },
            [theme.breakpoints.down('xs')]:
            {
                paddingRight: '70vw'
            }
        },
    });